import fingerprintJS from "@fingerprintjs/fingerprintjs";
import platform from "platform";

/*
 *  检测是否是移动端设备
 */
export const detectMobileOS = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "WindowsPhone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "Desktop";
};

export const getBrowserBrandName = () => {
  return platform.name;
};

/*
 *  检查当前浏览器环境是否是iOS设备（包括Safari和Chrome）
 *  @returns {boolean} 如果是iOS设备返回true，否则返回false
 */
export const isIOSDevice = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // 排除Windows Phone
  if (window.MSStream) {
    return false;
  }
  
  // 1. 检测iPhone和iPod（这些通常能检测到）
  if (/iPhone|iPod/.test(userAgent)) {
    return true;
  }
  
  // 2. 检测iOS上的Chrome浏览器（CriOS）
  if (/CriOS/i.test(userAgent)) {
    return true;
  }
  
  // 3. 检测iOS上的Firefox（FxiOS）
  if (/FxiOS/i.test(userAgent)) {
    return true;
  }
  
  // 4. 检测iOS上的Opera（OPiOS）
  if (/OPiOS/i.test(userAgent)) {
    return true;
  }
  
  // 5. 检测旧版本iPad（userAgent中包含iPad）
  if (/iPad/.test(userAgent)) {
    return true;
  }
  
  // 6. 检测新版本iPad（iPadOS 13+）：userAgent显示为Mac但实际是iPad
  // iPadOS 13+的Safari userAgent会显示为Mac，但可以通过以下特征检测：
  // - navigator.platform === 'MacIntel'
  // - 有触摸支持（navigator.maxTouchPoints > 1 或 'ontouchend' in window）
  // - 是Safari浏览器（不是Chrome等其他浏览器）
  var isMacIntel = navigator.platform === 'MacIntel';
  var hasTouchPoints = navigator.maxTouchPoints > 1;
  var hasTouchEvents = 'ontouchend' in window;
  var isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS|OPiOS|Edg/.test(userAgent);
  
  // iPadOS 13+的iPad在Safari中会显示为Mac，但有触摸支持
  if (isMacIntel && (hasTouchPoints || hasTouchEvents) && isSafari) {
    return true;
  }
  
  // 7. 检测iOS Safari的standalone模式（添加到主屏幕后的模式）
  if (window.navigator.standalone === true) {
    return true;
  }
  
  // 8. 使用platform库辅助检测（如果可用）
  try {
    if (platform && platform.os) {
      var osFamily = platform.os.family || '';
      if (/iOS|iPhone OS|iPad/.test(osFamily)) {
        return true;
      }
    }
  } catch (e) {
    // platform库可能不可用，忽略错误
  }
  
  return false;
};

/*
 *  生成设备ID
 */
export const generateVisitorId = async () => {
  let mos = detectMobileOS();
  let fp = await fingerprintJS.load();
  let result = await fp.get();

  let components = {...result.components};

  //经测试Chrome和Edge生成的VisitorId一样，需加入userAgentData用以区分
  let userAgentData = undefined;
  if (!!navigator.userAgentData) {
    let { brands, mobile, platform } = navigator.userAgentData;
    brands = brands.map((item) => {
      let newItem = {};
      Object.entries(item).filter(entry => entry[0].toLowerCase() !== "version").forEach(entry => {
        newItem[entry[0]] = entry[1];
      });
      return newItem;
    });
    userAgentData = { brands, mobile, platform };
  };

  components.userAgentData = {
    value: userAgentData,
    duration: 0
  };

  //PC的某些信息可能动态改变，计算VisitorId最好排除这些项
  if (mos === "Desktop") {
    delete components.screenResolution;
  }

  return fingerprintJS.hashComponents(components);
};
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

export const saveAdminInStore = (data) => {
  setStore("admin_auth_token", data.Token);
  setStore("admin_user_role", data.Role);
  setStore("admin_user_name", data.Name);
  setStore("securityKey", data.SecurityKey);
}
export const clearAdminInStore = () => {
  removeStore("admin_auth_token");
  removeStore("admin_user_role");
  removeStore("admin_user_name");
  removeStore("securityKey");
}
export const saveUserInStore = (data) => {
  setStore("auth_token", data.Token);
  setStore("user_role", data.Role);
  setStore("user_name", data.Name);
  setStore("user_student_id", data.StudentId);
  setStore("user_student_universityName", data.UniversityName);
  setStore("user_student_universityAbbreviation", data.UniversityAbbreviation);
  let hasStudentCourseNumber = 0;
  if (data.HasStudentCourseNumber) {
    hasStudentCourseNumber = 1;
  }
  setStore("user_student_hasStudentCourseNumber", hasStudentCourseNumber);

  let studentEnable = 0;
  if (data.StudentEnable) {
    studentEnable = 1;
  }
  setStore("user_student_enable", studentEnable);

  let hasSaturdayCourse = 0;
  if (data.HasSaturdayCourse) {
    hasSaturdayCourse = 1;
  }
  setStore("user_student_hasSaturdayCourse", hasSaturdayCourse);

  let hasSundayCourse = 0;
  if (data.HasSundayCourse) {
    hasSundayCourse = 1;
  }
  setStore("user_student_hasSundayCourse", hasSundayCourse);

  let hasWechat = 0;
  if (data.HasWechat) {
    hasWechat = 1;
  }
  setStore("user_student_hasWechat", hasWechat);

  let hasUnsignedContracts = 0;
  if (data.HasUnsignedContracts) {
    hasUnsignedContracts = 1;
  }
  setStore("user_student_hasUnsignedContracts", hasUnsignedContracts);
}

export const clearUserInStore = () => {
  removeStore("auth_token");
  removeStore("user_role");
  removeStore("user_name");
  removeStore("user_student_id");
  removeStore("user_student_universityName")
  removeStore("user_student_hasStudentCourseNumber");
  removeStore("user_student_enable");
  removeStore("user_student_hasSaturdayCourse");
  removeStore("user_student_hasSundayCourse");
  removeStore("user_student_hasWechat");
  removeStore("user_student_wechatPass");
  removeStore("user_student_hasUnsignedContracts");
}

export const saveUserWechatPassInStore = () => {
  let str = "pass";
  let code = compileStr(str);
  setStore("user_student_wechatPass", code);
}

export const getUserWechatPassInStore = () => {
  let code = getStore("user_student_wechatPass");
  if (code){
    return uncompileStr(code);
  }
  return "";
}

export const checkUserWechatPass = () => {
  let configStr = getStore("weChatConfig");
  if(!configStr)
    return false;

  let configObj = JSON.parse(uncompileStr(configStr));
  if (!configObj.Enable){
    return true;
  }
  let user_student_hasWechat = getStore("user_student_hasWechat");
  if (user_student_hasWechat == "1"){
    let value = getUserWechatPassInStore();
    if (value == "pass"){
      return true;
    }
  }
  return false;
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

export const getUrlRelativePath = () => {
  var url = window.location.toString();
  var arrUrl = url.split("//");


  var start = arrUrl[1].indexOf("/");
  var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符


  if (relUrl.indexOf("?") != -1) {
    relUrl = relUrl.split("?")[0];
  }
  return relUrl;
}

export const isInRole = (roleName) => {
  let result = false;
  if (!window.localStorage.getItem("user_role")) {
    return result;
  }
  let roles = window.localStorage.getItem("user_role").split(',');
  roles.forEach(role => {
    if (role == roleName) {
      result = true;
    }
  });
  return result;
}

export const isAdmin = () => {
  let roleId = window.localStorage.getItem("user_role");
  if (roleId == 1)
    return true;
  return false;
}

export const isStudent = () => {
  let roleId = window.localStorage.getItem("user_role");
  if (roleId == 2)
    return true;
  return false;
}

export const isFrontDesk = () => {
  let roleId = window.localStorage.getItem("user_role");
  if (roleId == 3)
    return true;
  return false;
}

// export const getTermCourseListCache = (termId)=>{
//   let jsonCourseList = window.localStorage.getItem("course_list");
//   let courseList = JSON.parse(jsonCourseList);
//   if(courseList && courseList.TermId == termId){
//     return courseList.List;
//   }
//   return null;
// }

// export const setTermCourseListCache = (courseList)=>{
//   let jsonCourseList = JSON.stringify(courseList);
//   setStore("course_list", jsonCourseList);
// }

// export const getContractListCache = ()=>{
//   let jsonContractList = window.localStorage.getItem("contract_list");
//   let list = JSON.parse(jsonContractList);
//   return list;
// }

// export const getContractViewModelListCache = ()=>{
//   let jsonContractList = window.localStorage.getItem("contract_viewmodel_list");
//   let list = JSON.parse(jsonContractList);
//   return list;
// }

// export const setContractViewModelListCache = (contractList)=>{
//   let jsonContractList = JSON.stringify(contractList);
//   setStore("contract_viewmodel_list", jsonContractList);
// }

// export const setContractListCache = (contractList)=>{
//   let jsonContractList = JSON.stringify(contractList);
//   setStore("contract_list", jsonContractList);
// }

export const getObjectInCache = (name) => {
  let strJson = window.localStorage.getItem(name);
  if (!strJson) {
    return false;
  }
  let obj = JSON.parse(strJson);
  return obj;
}

export const formatTime = (hour, mintue) => {
  if (hour == null || mintue == null) {
    return '';
  }
  if (typeof hour == 'string') {
    hour = parseInt(hour);
  }
  if (typeof mintue == 'string') {
    mintue = parseInt(mintue);
  }

  let ext = '';
  let hour_str = '';
  let mintue_str = mintue.toString();
  if (hour <= 12) {
    //if(hour == 12 && mintue == 30){
    if (hour == 12) {
      ext = 'PM';
    } else {
      ext = 'AM';
    }

    hour_str = hour.toString();
  } else {
    hour_str = (hour - 12).toString();
    ext = 'PM';
  }
  if (mintue_str.length == 1) {
    mintue_str = '0' + mintue_str;
  }

  return hour_str + ':' + mintue_str + ' ' + ext;
}

export const formatTimeFromInt60 = (value) => {
  let n = 0;
  if (!!value) {
    n = parseInt(value);
  }
  let hour = Math.floor(n / 60);
  let mintue = Math.floor(n % 60);
  return formatTime(hour, mintue);
}

export const formatTimeToInt60 = (time) => {
  let strHour = "";
  let strMinue = "";
  time = time.toLowerCase();

  if (time.indexOf(":") > 0) {
    let list = time.split(":");
    if (list.length > 1) {
      strHour = list[0];
      strMinue = list[1];
    }
  } else {
    strHour = time;
  }

  if (time.indexOf('am') > 0) {
    strMinue = strMinue.replace('am', '');
  } else if (time.indexOf('pm') > 0) {
    strMinue = strMinue.replace('pm', '');
  }

  let hour = parseInt(strHour);
  let mintue = parseInt(strMinue);

  if (time.indexOf('pm') > 0 && hour < 12) {
    hour += 12;
  }

  let result = hour * 60 + mintue;
  return result;
}

export const formatTimeFromInt = (value) => {
  let n = 0;
  if (!!value) {
    n = parseInt(value);
  }
  let hour = Math.floor(n / 100);
  let mintue = Math.floor(n % 100);

  return formatTime(hour, mintue);
}

export const formatTimeToInt = (time) => {
  let strHour = "";
  let strMinue = "";
  time = time.toLowerCase();

  if (time.indexOf(":") > 0) {
    let list = time.split(":");
    if (list.length > 1) {
      strHour = list[0];
      strMinue = list[1];
    }
  } else {
    strHour = time;
  }

  if (time.indexOf('am') > 0) {
    strMinue = strMinue.replace('am', '');
  } else if (time.indexOf('pm') > 0) {
    strMinue = strMinue.replace('pm', '');
  }

  let hour = parseInt(strHour);
  let mintue = parseInt(strMinue);

  if (time.indexOf('pm') > 0 && hour < 12) {
    hour += 12;
  }

  let result = hour * 100 + mintue;
  return result;
}

export const guid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export const formatDate = (date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

export const dateToDate = (date) => {
  var sDate = new Date();
  if (typeof date == 'object' &&
    typeof new Date().getMonth == "function"
  ) {
    sDate = date;
  } else if (typeof date == "string") {
    var arr = date.split('-')
    if (arr.length == 3) {
      sDate = new Date(arr[0] + '-' + arr[1] + '-' + arr[2]);
    }
  }

  return sDate;
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
  } else if (element.currentStyle) {
    target = element.currentStyle[attr];
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr];
  }
  //在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
}

/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback) => {
  let windowHeight = window.screen.height;
  let height;
  let setTop;
  let paddingBottom;
  let marginBottom;
  let requestFram;
  let oldScrollTop;

  document.body.addEventListener('scroll', () => {
    loadMore();
  }, false)
  //运动开始时获取元素 高度 和 offseTop, pading, margin
  element.addEventListener('touchstart', () => {
    height = element.offsetHeight;
    setTop = element.offsetTop;
    paddingBottom = getStyle(element, 'paddingBottom');
    marginBottom = getStyle(element, 'marginBottom');
  }, {
    passive: true
  })

  //运动过程中保持监听 scrollTop 的值判断是否到达底部
  element.addEventListener('touchmove', () => {
    loadMore();
  }, {
    passive: true
  })

  //运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
  element.addEventListener('touchend', () => {
    oldScrollTop = document.body.scrollTop;
    moveEnd();
  }, {
    passive: true
  })

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop;
        loadMore();
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
        //为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
        height = element.offsetHeight;
        loadMore();
      }
    })
  }

  const loadMore = () => {
    if (document.body.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom) {
      callback();
    }
  }
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
  let requestFram;
  let oldScrollTop;

  document.addEventListener('scroll', () => {
    showBackFun();
  }, false)
  document.addEventListener('touchstart', () => {
    showBackFun();
  }, {
    passive: true
  })

  document.addEventListener('touchmove', () => {
    showBackFun();
  }, {
    passive: true
  })

  document.addEventListener('touchend', () => {
    oldScrollTop = document.body.scrollTop;
    moveEnd();
  }, {
    passive: true
  })

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop;
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
      }
      showBackFun();
    })
  }

  //判断是否达到目标点
  const showBackFun = () => {
    if (document.body.scrollTop > 500) {
      callback(true);
    } else {
      callback(false);
    }
  }
}


/**
 * 运动效果
 * @param {HTMLElement} element   运动对象，必选
 * @param {JSON}        target    属性：目标值，必选
 * @param {number}      duration  运动时间，可选
 * @param {string}      mode      运动模式，可选
 * @param {function}    callback  可选，回调函数，链式动画
 */
export const animate = (element, target, duration = 400, mode = 'ease-out', callback) => {
  clearInterval(element.timer);

  //判断不同参数的情况
  if (duration instanceof Function) {
    callback = duration;
    duration = 400;
  } else if (duration instanceof String) {
    mode = duration;
    duration = 400;
  }

  //判断不同参数的情况
  if (mode instanceof Function) {
    callback = mode;
    mode = 'ease-out';
  }

  //获取dom样式
  const attrStyle = attr => {
    if (attr === "opacity") {
      return Math.round(getStyle(element, attr, 'float') * 100);
    } else {
      return getStyle(element, attr);
    }
  }
  //根字体大小，需要从此将 rem 改成 px 进行运算
  const rootSize = parseFloat(document.documentElement.style.fontSize);

  const unit = {};
  const initState = {};

  //获取目标属性单位和初始样式值
  Object.keys(target).forEach(attr => {
    if (/[^\d^\.]+/gi.test(target[attr])) {
      unit[attr] = target[attr].match(/[^\d^\.]+/gi)[0] || 'px';
    } else {
      unit[attr] = 'px';
    }
    initState[attr] = attrStyle(attr);
  });

  //去掉传入的后缀单位
  Object.keys(target).forEach(attr => {
    if (unit[attr] == 'rem') {
      target[attr] = Math.ceil(parseInt(target[attr]) * rootSize);
    } else {
      target[attr] = parseInt(target[attr]);
    }
  });


  let flag = true; //假设所有运动到达终点
  const remberSpeed = {}; //记录上一个速度值,在ease-in模式下需要用到
  element.timer = setInterval(() => {
    Object.keys(target).forEach(attr => {
      let iSpeed = 0; //步长
      let status = false; //是否仍需运动
      let iCurrent = attrStyle(attr) || 0; //当前元素属性址
      let speedBase = 0; //目标点需要减去的基础值，三种运动状态的值都不同
      let intervalTime; //将目标值分为多少步执行，数值越大，步长越小，运动时间越长
      switch (mode) {
        case 'ease-out':
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
          break;
        case 'linear':
          speedBase = initState[attr];
          intervalTime = duration * 20 / 400;
          break;
        case 'ease-in':
          let oldspeed = remberSpeed[attr] || 0;
          iSpeed = oldspeed + (target[attr] - initState[attr]) / duration;
          remberSpeed[attr] = iSpeed
          break;
        default:
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
      }
      if (mode !== 'ease-in') {
        iSpeed = (target[attr] - speedBase) / intervalTime;
        iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
      }
      //判断是否达步长之内的误差距离，如果到达说明到达目标点
      switch (mode) {
        case 'ease-out':
          status = iCurrent != target[attr];
          break;
        case 'linear':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        case 'ease-in':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        default:
          status = iCurrent != target[attr];
      }

      if (status) {
        flag = false;
        //opacity 和 scrollTop 需要特殊处理
        if (attr === "opacity") {
          element.style.filter = "alpha(opacity:" + (iCurrent + iSpeed) + ")";
          element.style.opacity = (iCurrent + iSpeed) / 100;
        } else if (attr === 'scrollTop') {
          element.scrollTop = iCurrent + iSpeed;
        } else {
          element.style[attr] = iCurrent + iSpeed + 'px';
        }
      } else {
        flag = true;
      }

      if (flag) {
        clearInterval(element.timer);
        if (callback) {
          callback();
        }
      }
    })
  }, 20);
}

export const typeOf = (val) => {
  return Object.prototype.toString.call(val).match(/^\[object\s(.*)\]$/)[1].toLowerCase();
};

export const arrayEquals = (array1, array2) => {
  if (array1.length != array2.length) return false;

  let sameItemArr = [];
  for (let i = 0; i < array1.length; i++) {
    let isExist = false;
    for (let j = 0; j < array2.length; j++) {
      if (JSON.stringify(array2[j]) == JSON.stringify(array1[i])) {
        isExist = true;
        break;
      }
    }
    if (isExist) sameItemArr.push(array1[i]);
  }

  return sameItemArr.length == array1.length;
};

export const getCourseTypeText = (courseType) => {
  let courseTypeText = "";
  switch (courseType) {
    case 1: {
      courseTypeText = "大学补习";
      break;
    }
    case 2: {
      courseTypeText = "应试英语";
      break;
    }
    case 3: {
      courseTypeText = "职业培训";
      break;
    }
  }
  return courseTypeText;
};

export const getCourseTypeList = () => {
  let list = [
    { Key: 1, Value: "大学补习" },
    { Key: 2, Value: "应试英语" },
    { Key: 3, Value: "职业培训" }];
  return list;
};

export const convertToFloat = (value) => {
  let f = 0;
  if (typeof value == "string") {
    f = parseFloat(value);
  } else {
    f = value;
  }
  let str = f.toFixed(2);
  return parseFloat(str);
};

export const getGlobalPriceSettingByType = (gpSettings, type) => {
  let result = null;

  if (!!gpSettings && gpSettings.length > 0) {
    let price = gpSettings.filter(i => i.Type == type);
    if (!!price && price.length > 0) {
      result = price[0];
    }
  }

  return result;
};

export const getUniversityCourseTypeList = () => {
  let list = [
    { Key: 1, Value: "Lecture" },
    { Key: 2, Value: "Lab" },
    { Key: 3, Value: "Tutorial" }];
  return list;
};

//对字符串进行加密
export const compileStr = (code) => {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}
//字符串进行解密
export const uncompileStr = (code) => {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

export const timeDown = (id, endDateStr) => {
  let str = getTimeDiff(endDateStr);
  //输出到页面
  $("#timeDown1").val("还剩:" + str);
  //延迟一秒执行自己
  setTimeout(function () {
    timeDown(id, endDateStr);
  }, 1000)
}

export const getTimeDiff = (endDateStr) => {
  var endDate = new Date(endDateStr);
  //当前时间
  var nowDate = new Date();
  //相差的总秒数
  var totalSeconds = parseInt((endDate - nowDate) / 1000);
  //天数
  var days = Math.floor(totalSeconds / (60 * 60 * 24));
  //取模（余数）
  var modulo = totalSeconds % (60 * 60 * 24);
  //小时数
  var hours = Math.floor(modulo / (60 * 60));
  modulo = modulo % (60 * 60);
  //分钟
  var minutes = Math.floor(modulo / 60);
  //秒
  var seconds = modulo % 60;

  return days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒";
}

export const getTimezoneName = () => {
  let tmSummer = new Date(Date.UTC(2005, 6, 30, 0, 0, 0, 0));
  let so = -1 * tmSummer.getTimezoneOffset();
  let tmWinter = new Date(Date.UTC(2005, 12, 30, 0, 0, 0, 0));
  let wo = -1 * tmWinter.getTimezoneOffset();

  if (-660 == so && -660 == wo) return 'Pacific/Midway';
  if (-600 == so && -600 == wo) return 'Pacific/Tahiti';
  if (-570 == so && -570 == wo) return 'Pacific/Marquesas';
  if (-540 == so && -600 == wo) return 'America/Adak';
  if (-540 == so && -540 == wo) return 'Pacific/Gambier';
  if (-480 == so && -540 == wo) return 'US/Alaska';
  if (-480 == so && -480 == wo) return 'Pacific/Pitcairn';
  if (-420 == so && -480 == wo) return 'US/Pacific';
  if (-420 == so && -420 == wo) return 'US/Arizona';
  if (-360 == so && -420 == wo) return 'US/Mountain';
  if (-360 == so && -360 == wo) return 'America/Guatemala';
  if (-360 == so && -300 == wo) return 'Pacific/Easter';
  if (-300 == so && -360 == wo) return 'US/Central';
  if (-300 == so && -300 == wo) return 'America/Bogota';
  if (-240 == so && -300 == wo) return 'US/Eastern';
  if (-240 == so && -240 == wo) return 'America/Caracas';
  if (-240 == so && -180 == wo) return 'America/Santiago';
  if (-180 == so && -240 == wo) return 'Canada/Atlantic';
  if (-180 == so && -180 == wo) return 'America/Montevideo';
  if (-180 == so && -120 == wo) return 'America/Sao_Paulo';
  if (-150 == so && -210 == wo) return 'America/St_Johns';
  if (-120 == so && -180 == wo) return 'America/Godthab';
  if (-120 == so && -120 == wo) return 'America/Noronha';
  if (-60 == so && -60 == wo) return 'Atlantic/Cape_Verde';
  if (0 == so && -60 == wo) return 'Atlantic/Azores';
  if (0 == so && 0 == wo) return 'Africa/Casablanca';
  if (60 == so && 0 == wo) return 'Europe/London';
  if (60 == so && 60 == wo) return 'Africa/Algiers';
  if (60 == so && 120 == wo) return 'Africa/Windhoek';
  if (120 == so && 60 == wo) return 'Europe/Amsterdam';
  if (120 == so && 120 == wo) return 'Africa/Harare';
  if (180 == so && 120 == wo) return 'Europe/Athens';
  if (180 == so && 180 == wo) return 'Africa/Nairobi';
  if (240 == so && 180 == wo) return 'Europe/Moscow';
  if (240 == so && 240 == wo) return 'Asia/Dubai';
  if (270 == so && 210 == wo) return 'Asia/Tehran';
  if (270 == so && 270 == wo) return 'Asia/Kabul';
  if (300 == so && 240 == wo) return 'Asia/Baku';
  if (300 == so && 300 == wo) return 'Asia/Karachi';
  if (330 == so && 330 == wo) return 'Asia/Calcutta';
  if (345 == so && 345 == wo) return 'Asia/Katmandu';
  if (360 == so && 300 == wo) return 'Asia/Yekaterinburg';
  if (360 == so && 360 == wo) return 'Asia/Colombo';
  if (390 == so && 390 == wo) return 'Asia/Rangoon';
  if (420 == so && 360 == wo) return 'Asia/Almaty';
  if (420 == so && 420 == wo) return 'Asia/Bangkok';
  if (480 == so && 420 == wo) return 'Asia/Krasnoyarsk';
  if (480 == so && 480 == wo) return 'Australia/Perth';
  if (540 == so && 480 == wo) return 'Asia/Irkutsk';
  if (540 == so && 540 == wo) return 'Asia/Tokyo';
  if (570 == so && 570 == wo) return 'Australia/Darwin';
  if (570 == so && 630 == wo) return 'Australia/Adelaide';
  if (600 == so && 540 == wo) return 'Asia/Yakutsk';
  if (600 == so && 600 == wo) return 'Australia/Brisbane';
  if (600 == so && 660 == wo) return 'Australia/Sydney';
  if (630 == so && 660 == wo) return 'Australia/Lord_Howe';
  if (660 == so && 600 == wo) return 'Asia/Vladivostok';
  if (660 == so && 660 == wo) return 'Pacific/Guadalcanal';
  if (690 == so && 690 == wo) return 'Pacific/Norfolk';
  if (720 == so && 660 == wo) return 'Asia/Magadan';
  if (720 == so && 720 == wo) return 'Pacific/Fiji';
  if (720 == so && 780 == wo) return 'Pacific/Auckland';
  if (765 == so && 825 == wo) return 'Pacific/Chatham';
  if (780 == so && 780 == wo) return 'Pacific/Enderbury'
  if (840 == so && 840 == wo) return 'Pacific/Kiritimati';
  return 'US/Pacific';
}

export const toDecimal = (x) => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}

export const setMediaDevices = () => {
  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  }
  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {
      var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      //navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      if (!getUserMedia) {
        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
      }
      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    }
  }
}

export const getBrowerInfo = () => {

  let userAgent = window.navigator.userAgent.toLowerCase()
  let browserType = ''
  let browserVersion = ''
  let isIE = userAgent.match(/msie/) != null || userAgent.match(/trident/) != null
  // 浏览器类型-IE
  if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
    browserType = 'IE'
    browserVersion = getIeVersion()
  }
  // 欧朋
  else if (window.opera || (userAgent.indexOf("opr") > 0)) {
    browserType = '欧朋'
    browserVersion = getOperaVersion(userAgent)
  }
  // UC
  else if (userAgent.indexOf("ubrowser") > 0) {
    browserType = 'UC'
    browserVersion = userAgent.match(/ubrowser\/([\d.]+)/)[1]
  }
  // 百度
  else if (userAgent.indexOf("bidubrowser") > 0) {
    browserType = '百度'
    browserVersion = userAgent.match(/bidubrowser\/([\d.]+)/)[1]
  }
  // 搜狗
  else if (userAgent.indexOf("metasr") > 0 || userAgent.indexOf("se 2.x") > 0) {
    browserType = '搜狗'
    // browserVersion =  userAgent.match(/metasr\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("tencenttraveler") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/tencenttraveler\/([\d.]+)/)[1]
  }
  // QQ
  else if (userAgent.indexOf("qqbrowser") > 0) {
    browserType = 'QQ'
    browserVersion = userAgent.match(/qqbrowser\/([\d.]+)/)[1]
  }
  // 遨游
  else if (userAgent.indexOf("maxthon") > 0) {
    browserType = '遨游'
    browserVersion = userAgent.match(/maxthon\/([\d.]+)/)[1]
  }
  // 火狐
  else if (userAgent.indexOf("firefox") > 0) {
    browserType = '火狐'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  }
  // edge
  else if (userAgent.indexOf("edge") > 0) {
    browserType = 'Edge'
    browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
  }
  else if (userAgent.indexOf("edg") > 0) {
    browserType = 'Edge'
    browserVersion = userAgent.match(/edg\/([\d.]+)/)[1]
  }
  // 谷歌/360
  else if (userAgent.indexOf("chrome") > 0) {
    if (validate360('type', 'application/x360mmplugin')) {
      browserType = '360'
      // browserVersion =  userAgent.match(/chrome\/([\d.]+)/)[1]
    } else {
      browserType = '谷歌'
      browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
    }
  }
  // 苹果
  else if (userAgent.indexOf("safari") > -1) {
    browserType = 'safari'
    browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
  }
  return browserType + ' ' + browserVersion
}

function getIeVersion() {
  let IEMode = document.documentMode
  let rMsie = /(msie\s|trident.*rv:)([\w.]+)/;
  let ma = window.navigator.userAgent.toLowerCase()
  let match = rMsie.exec(ma);
  try {
    return match[2];
  } catch (e) {
    return IEMode;
  }
}

function getOperaVersion(userAgent) {
  try {
    if (window.opera) {
      return userAgent.match(/opera.([\d.]+)/)[1];
    } else if (userAgent.indexOf("opr") > 0) {
      return userAgent.match(/opr\/([\d.]+)/)[1];
    }
  } catch (e) {
    return 0;
  }
}

function validate360(option, value) {
  let mimeTypes = window.navigator.mimeTypes
  for (let mt in mimeTypes) {
    if (mimeTypes[mt][option] == value) {
      return true;
    }
  }
  return false;
}

export const downloadFile = (result, isReview) => {
  let blob = result.data;
  let href = window.URL.createObjectURL(blob);
  let safari = isSafari();
  if (safari || isReview) {
    window.open(href, '_blank');
  } else {
    let fileName = decodeURIComponent(result.filename);
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.target = "_blank";
    link.download = fileName;
    link.click();
    window.setTimeout(()=>{
      //释放内存
      window.URL.revokeObjectURL(link.href);
    }, 1000)
  }
}

export const openLink = (href) => {
  let safari = isSafari();
  if (safari) {
    window.open(href, "_blank");
  } else {
    var link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.click();
    window.setTimeout(() => {
      //释放内存
      window.URL.revokeObjectURL(link.href);
    }, 1000);
  }
}

export const isSafari = (userAgent) => {
  if (typeof userAgent == undefined) {
    userAgent = navigator.userAgent;
  }
  return /^((?!chrome|android).)*safari/i.test(userAgent);
}



// WEBPACK FOOTER //
// ./src/config/mUtils.js